var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOccurrenceSidebarArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-arrow-1920781",
    transform: "translate(18 14) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M84.4,84.682l5.552,5.648a1.322,1.322,0,0,0,1.876,0,1.378,1.378,0,0,0,0-1.908l-3.278-3.354h12.126a1.35,1.35,0,0,0,0-2.7H88.545l3.278-3.335a1.378,1.378,0,0,0,0-1.908,1.311,1.311,0,0,0-1.895,0L84.4,82.755a1.384,1.384,0,0,0-.4.964,1.307,1.307,0,0,0,.4.964Z",
    transform: "translate(-83.997 -76.721)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccurrenceSidebarArrowIcon);
export default __webpack_public_path__ + "static/media/occurrence_sidebar_arrow_icon.97e9cf1b751021eb0f465fadd3d48c60.svg";
export { ForwardRef as ReactComponent };